import { Button, Grid, Paper, TextareaAutosize, TextField } from '@mui/material';
import React from 'react';
import { TaskTypeProps } from '../types';
import {
    handleDescriptionChange,
    handleOptionTextChange,
    handleOptionImageChange,
    handleAddImage,
    handleAddPlate,
} from '../actions';
import strings from '../../../resources/strings';
import SkillPoints from '../../SkillPoints/SkillPoints';
import OptionTypes from '../../../resources/enums/OptionTypes';
import AddImage from '../../AddImage/AddImage';
import { storage } from '../../../resources/storage';
import TaskFeedback from '../../Feedback/TaskFeedback';

const Collage: React.FC<TaskTypeProps> = (props) => {
    let platesCount = 0;
    let imagesCount = 0;

    const increasePlatesCount = () => {
        platesCount += 1;
    };

    return (
        <div className="option-container">
            <Paper className="option-paper" elevation={2}>
                <Grid container>
                    <Grid item xs={6}>
                        {props.languages.map((lang) => {
                            return (
                                <TextareaAutosize
                                    key={`description_${lang.code}`}
                                    defaultValue={props.task.description?.[lang.code]}
                                    id={`description_${lang.code}`}
                                    placeholder="Description"
                                    name={`description_${lang.code}`}
                                    style={{ display: lang.code === props.language ? 'block' : 'none' }}
                                    maxRows={6}
                                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                                        handleDescriptionChange(
                                            e,
                                            props.setTasks,
                                            props.task,
                                            props.tasks,
                                            props.language,
                                        )
                                    }
                                ></TextareaAutosize>
                            );
                        })}
                        {props.options.map((item, index) => {
                            return item.type === OptionTypes.Text ? (
                                <div key={`plate_${index}`}>
                                    {increasePlatesCount()}
                                    {props.languages.map((lang) => (
                                        <TextField
                                            fullWidth
                                            style={{
                                                display: lang.code === props.language ? 'block' : 'none',
                                                marginTop: '1rem',
                                            }}
                                            key={`plate_${lang.code}_${index}`}
                                            defaultValue={item.text?.[lang.code]}
                                            variant="outlined"
                                            required={false}
                                            type="text"
                                            id={`plate_${lang.code}_${platesCount}`}
                                            label={`Plate ${platesCount}`}
                                            name={`plate_${lang.code}_${platesCount}`}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                handleOptionTextChange(
                                                    e,
                                                    props.setOptions,
                                                    item,
                                                    props.options,
                                                    props.language,
                                                );
                                            }}
                                        ></TextField>
                                    ))}
                                </div>
                            ) : (
                                <div key={`image_${index}`}>
                                    <h3 className="only-description-image-label">Image {(imagesCount += 1)}</h3>
                                    <AddImage
                                        path={`${storage.options.replace('*Task*', props.task.id)}/${item.id}`}
                                        showMessage={false}
                                        sendOnDrop={true}
                                        setGetImgAddress={(url: string) => {
                                            handleOptionImageChange(props.setOptions, props.options, item, url);
                                        }}
                                        actualEventFile={item.imageUrl}
                                    ></AddImage>
                                </div>
                            );
                        })}
                        <div className="buttons-section">
                            <Button
                                className="add-btn"
                                variant="outlined"
                                onClick={() => handleAddImage(props.setOptions, props.options)}
                            >
                                {strings.tasks.addImgBtnLabel}
                            </Button>
                            <Button
                                className="add-btn"
                                variant="outlined"
                                onClick={() => handleAddPlate(props.setOptions, props.options)}
                            >
                                {strings.tasks.addPlateBtnLabel}
                            </Button>
                        </div>
                    </Grid>
                    <Grid item xs={12} className="points-container-bottom">
                        {props.skills?.map((skill) => {
                            return (
                                <SkillPoints
                                    key={skill.id}
                                    data={props.skills}
                                    id={skill.id}
                                    itemId={props.task.id}
                                    language={props.language}
                                    defaultValues={props.task.skills}
                                    items={props.tasks}
                                    setItems={props.setTasks}
                                ></SkillPoints>
                            );
                        })}
                    </Grid>
                    <Grid item xs={12}>
                        <TaskFeedback
                            language={props.language}
                            languages={props.languages}
                            task={props.task}
                            tasks={props.tasks}
                            setTasks={props.setTasks}
                        />
                    </Grid>
                </Grid>
            </Paper>
        </div>
    );
};

export default Collage;
